export default {
    finance: {
        loanPrograms: {
            title: "Programmes de pret",
            create: "Creer un programme de pret",
            edit: "Modifier le programme de pret",
            details: "Details du programme",
            programTitle: "Titre du programme",
            programLogo: "Logo du programme",
            applicationForm: "Formulaire de demande",
            viewApplications: "Voir les demandes",
            cooperative: "Cooperative",
            bank: "Banque",
            status: "Statut",
            allStatuses: "Tous les statuts",
            active: "Actif",
            inactive: "Inactif",
            approvalFlowSetting: "Configuration du flux d approbation",
            concludeBeforeBank: "Finaliser une demande de pret avant de l envoyer a la banque.",
            allowBankRequestInfo: "Autoriser la banque a demander plus d informations au demandeur.",
            currency: "Devise",
            loanAmountMin: "Montant du pret - Minimum",
            loanAmountMax: "Montant du pret - Maximum",
            term: "Duree",
            yield: "Rendement",
            typeOfFinancing: "Type de financement",
            gracePeriod: "Periode de grace",
            country: "Pays",
            regions: "Regions",
            crops: "Cultures",
            dataFields: "Champs de donnees",
            dataFieldsConfigured: "Champs de donnees configures pour ce programme de pret",
            signature: "Signature",
            viewSignatureFile: "Voir la signature / le fichier",
            description: "Description",
            conditionsRequirements: "Conditions et exigences",
            digitalSignature: "Signature numerique",
            fileUpload: "Televersement de fichier",
            failedLoadLoanProgramDetails: "Echec du chargement des details du programme de pret",
            failedLoadLoanProgram: "Echec du chargement du programme de pret",
            failedLoadApplicationForm: "Echec du chargement du formulaire de demande",
            loanProgramUpdatedSuccess: "Programme de pret mis a jour avec succes",
            loanProgramCreatedSuccess: "Programme de pret cree avec succes",
            applicationFormUpdatedSuccess: "Formulaire de demande mis a jour avec succes",
            failedUpdateLoanProgram: "Echec de la mise a jour du programme de pret",
            failedCreateLoanProgram: "Echec de la creation du programme de pret",
            failedUpdateApplicationForm: "Echec de la mise a jour du formulaire de demande",
            fillRequiredFields: "Veuillez remplir tous les champs obligatoires",
            fileUploadRequiredFor: "Un televersement de fichier est requis pour",
            selectAtLeastOneOptionFor: "Selectionnez au moins une option pour",
            fieldRequired: "Ce champ est obligatoire",
            chooseValidOptionFor: "Choisissez une option valide pour",
            enterValidAmountFor: "Saisissez un montant valide pour",
            selectValidUnitFor: "Selectionnez une unite valide pour",
            step1ProgramDetails: "Etape 1: Details du programme",
            step2ApplicationForm: "Etape 2: Formulaire de demande",
            months: "mois",
            years: "ans",
            days: "jours",
            weeks: "semaines",
            previewForm: "APERCU DU FORMULAIRE",
            backUpper: "RETOUR",
            basicInformation: "Informations de base",
            basicInformationHint: "Saisissez les informations de base du programme de pret.",
            enterProgramTitle: "Saisissez le titre du programme",
            attachProgramLogo: "Ajouter le logo du programme",
            selectProgramLogoImage: "Selectionnez l image du logo du programme",
            selectFileUploadProgramLogo: "Selectionnez le fichier a televerser pour le logo du programme",
            orDragDrop: "ou glissez-deposez ici",
            removeFile: "Supprimer le fichier",
            loanProgramSettings: "Parametres du programme de pret",
            loanProgramSettingsHint: "Saisissez les parametres du programme de pret.",
            selectBank: "Selectionnez une banque",
            applicationApproval: "Approbation de la demande",
            applicationProcess: "Processus de demande",
            loanDetails: "Details du pret",
            loanDetailsHint: "Saisissez les details du pret pour le programme.",
            selectCurrency: "Selectionnez la devise",
            enterMinLoanAmount: "Saisissez le montant minimum du pret",
            enterMaxLoanAmount: "Saisissez le montant maximum du pret",
            enterHere: "Saisissez ici",
            interestRate: "Taux d interet",
            yieldPerYear: "Rendement - par an",
            enterYieldPerYear: "Saisissez le rendement annuel",
            selectTypeOfFinancing: "Selectionnez le type de financement",
            gracePeriodMax: "Periode de grace - Maximum",
            selectCrops: "Selectionnez les cultures",
            selectCountry: "Selectionnez le pays",
            selectRegions: "Selectionnez les regions",
            addNewDataField: "AJOUTER UN NOUVEAU CHAMP DE DONNEES",
            enterProgramDescription: "Saisissez la description du programme",
            programApplicationForm: "Formulaire de demande du programme",
            defineAndManageCustomDataFields: "Definissez et gerez des champs de donnees personnalises pour la demande de pret.",
            addDataField: "AJOUTER UN CHAMP DE DONNEES",
            dataField: "Champ de donnees",
            type: "Type",
            subdata: "Sous-donnee",
            mandatory: "Obligatoire",
            group: "Groupe",
            yes: "Oui",
            no: "Non",
            noDataFieldsYet: "Aucun champ de donnees ajoute pour le moment. Cliquez sur AJOUTER UN CHAMP DE DONNEES pour en creer un.",
            textField: "Champ texte",
            textArea: "Zone de texte",
            textFieldNumeric: "Champ numerique",
            radioButton: "Bouton radio",
            checkBoxes: "Cases a cocher",
            dropdown: "Liste deroulante",
            measurementUnit: "Unite de mesure",
            attachFile: "Joindre un fichier",
            digitalSignatureLabel: "Signature numerique",
            dataList: "Liste de donnees",
            date: "Date",
            selectDataType: "Selectionner le type de donnees",
            fieldTitle: "Titre du champ",
            groupTitle: "Titre du groupe",
            enterGroupTitle: "Saisissez le titre du groupe",
            allowMultipleInputs: "Autoriser plusieurs entrees",
            allowedFileTypes: "Types de fichiers autorises",
            imageJpegGifPng: "Image (JPEG, GIF, PNG)",
            videoMp4: "Video (MP4)",
            docx: "DOCX",
            options: "Options",
            typeHere: "Tapez ici",
            unitType: "Type d unite",
            selectUnitType: "Selectionnez le type d unite",
            selectType: "Selectionnez le type",
            allowUserToChangeUnitType: "Autoriser l utilisateur a changer le type d unite",
            help: "Aide",
            writeHelpTextUsers: "Ecrivez un texte d aide pour les utilisateurs.",
            helpText: "Texte d aide",
            addHelpTextForThisDataField: "Ajouter un texte d aide pour ce champ de donnees",
            addFieldToGroup: "Ajouter un champ au groupe",
            cancelUpper: "ANNULER",
            submitUpper: "SOUMETTRE",
            groupTitleRequired: "Le titre du groupe est requis",
            atLeastOneFieldRequiredInGroup: "Au moins un champ est requis dans un groupe",
            fieldTitleRequiredForAllGroupFields: "Le titre du champ est requis pour tous les champs du groupe",
            atLeastOneOptionRequiredFor: "Au moins une option est requise pour",
            atLeastOneFileTypeMustBeSelected: "Au moins un type de fichier doit etre selectionne",
            fieldTitleRequired: "Le titre du champ est requis",
            atLeastOneOptionRequired: "Au moins une option est requise",
        },
        loanApplications: {
            activityDescription: "Description de l'activite",
            activityLog: "Journal d'activite",
            addAnyInternalNotesOrReviewCommentsAboutThisLoanApplication: "Ajoutez des notes internes ou des commentaires de revision sur cette demande de pret.",
            additionalInformationRequested: "Informations supplementaires demandees",
            additionalLoanRelatedQuestionsAndSupportingDocuments: "Questions supplementaires liees au pret et pieces justificatives.",
            additionalQuestions: "Questions supplementaires",
            address: "Adresse",
            amount: "Montant",
            applicantDetails: "Coordonnees du demandeur",
            applicationHasBeenSentToTheBankForApproval: "La demande a ete envoyee a la banque pour approbation.",
            applicationId: "ID de la demande",
            applicationIdAndSubmissionDate: "ID de la demande et date de soumission",
            apply: "Appliquer",
            approvalProcess: "Processus d'approbation",
            approvalProcessHasBeenStartedYouCanNowFillFinalizeContractAndLoanDetails: "Le processus d'approbation a demarre. Vous pouvez maintenant renseigner Finaliser le contrat et les details du pret.",
            approve: "Approuver",
            approved: "Approuve",
            areYouSureYouWantToApproveTheLoanApplication: "Voulez-vous vraiment approuver la demande de pret ?",
            areYouSureYouWantToRejectTheLoanApplication: "Voulez-vous vraiment rejeter la demande de pret ?",
            areYouSureYouWantToSendTheApplicationToTheBankForApprovalProcess: "Voulez-vous vraiment envoyer la demande a la banque pour le processus d'approbation ?",
            areYouSureYouWantToStartTheApprovalProcess: "Voulez-vous vraiment demarrer le processus d'approbation ?",
            area: "Superficie",
            areaHa: "Superficie (ha)",
            attachContractOptional: "Joindre le contrat (facultatif)",
            attachment: "Piece jointe",
            back: "Retour",
            cancel: "Annuler",
            circular: "Circulaire",
            close: "Fermer",
            closeUpper: "FERMER",
            confirm: "Confirmer",
            confirmation: "Confirmation",
            contract: "Contrat",
            couldNotLoadLoanApplication: "Impossible de charger la demande de pret.",
            couldNotSendRequest: "Impossible d'envoyer la requete.",
            couldNotUpdateApplication: "Impossible de mettre a jour la demande.",
            country: "Pays",
            customization: "Personnalisation",
            date: "Date",
            dateAndTime: "Date et heure",
            describeHere: "Decrivez ici",
            description: "Description",
            digitallySigned: "Signe numeriquement",
            disclaimerTitle: "Avertissement",
            disbursedAmount: "Montant debourse",
            disbursementScheduleFromBankToFarmer: "Calendrier des deboursements de la banque vers l'agriculteur.",
            doYouWantUsToCollectTheContractSignature: "Souhaitez-vous que nous recueillions la signature du contrat ?",
            doYouWantUsToCollectTheContractSignatureIfYesAttachTheContractOptionalAndWeWillSendItToTheFarmerToSignInTheAppIfNoTheContractIsAlreadySignedOrWillBeSignedOfflineAfterYouAttachAndSaveTheContractWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Souhaitez-vous que nous recueillions la signature du contrat ? Si oui, joignez le contrat (facultatif) et nous l'enverrons a l'agriculteur pour signature dans l'application. Si non, le contrat est deja signe ou le sera hors ligne. Apres avoir joint et enregistre, le contrat sera envoye a l'agriculteur pour signature ; vous recevrez une notification une fois signe.",
            download: "Telecharger",
            dueDate: "Date d'echeance",
            email: "Courriel",
            enterHere: "Saisissez ici",
            error: "Erreur",
            farm: "Exploitation",
            farmDetails: "Details de l'exploitation",
            farmReports: "Rapports d'exploitation",
            farmer: "Agriculteur",
            farmerResponse: "Reponse de l'agriculteur",
            farmerUpdates: "Mises a jour de l'agriculteur",
            farmReportsSoilDisclaimer: "Les informations de cette section sont fournies a titre indicatif uniquement. Elles ne remplacent pas une analyse de sol professionnelle en laboratoire. Utilisez-les seulement si d'autres options d'analyse ne sont pas disponibles. Consultez toujours des experts agricoles avant de decider.",
            farmReportsYieldBullet1: "Il est impossible de prevoir avec precision la meteo sur toute une saison ; dans certains cas les agriculteurs peuvent perdre toute la recolte apres une grele ou une inondation (d'autant plus avec le rechauffement climatique et ses irregularites).",
            farmReportsYieldBullet2: "Les rendements dependent fortement des pratiques de gestion. Par exemple, en cas d'application tardive de pesticides ou d'un arrosage insuffisant, les rendements peuvent differer fortement des previsions ; cela echappe aussi a notre controle.",
            farmReportsYieldBullet3: "De nombreux autres facteurs similaires peuvent entrainer des erreurs importantes dans les previsions de rendement par IA.",
            farmReportsYieldBullet4: "Si l'agriculteur fournit des rendements historiques (mode AVANCE), les previsions sont en general plus precises qu'en mode par defaut (non AVANCE).",
            farmReportsYieldUncertaintyIntro: "Dans nos previsions de rendement, l'incertitude peut atteindre 100 % car de nombreux facteurs echappent a notre controle, notamment :",
            forecastedYields: "Rendements prevus",
            graph: "Graphique",
            yieldsKgAxis: "Rendements (kg)",
            yieldForecasts: "Previsions de rendement",
            farmerUploadedAttachmentS: "L'agriculteur a televerse une ou des piece(s) jointe(s).",
            finalizeContract: "Finaliser le contrat",
            financeManagement: "Gestion financiere",
            firstName: "Prenom",
            generatePaymentSchedule: "GENERER LE CALENDRIER DE PAIEMENT",
            geolocation: "Geolocalisation",
            gracePeriod: "Periode de grace",
            gracePeriodType: "Type de periode de grace",
            historyOfActionsTakenOnThisLoanApplication: "Historique des actions effectuees sur cette demande de pret.",
            ifYouWantUsToCollectTheApplicantSSignatureChooseYesAndAttachTheContractAfterYouSaveItWillBeSentToTheFarmerToSignInTheAppYouLlReceiveANotificationOnceSignedContractUploadIsOptionalEGIfTheContractIsAlreadySignedOrWillBeSignedOffline: "Pour que nous recueillions la signature du demandeur, choisissez Oui et joignez le contrat. Apres enregistrement, il sera envoye a l'agriculteur pour signature dans l'application ; vous recevrez une notification une fois signe. Le televersement du contrat est facultatif (p. ex. deja signe ou a signer hors ligne).",
            information: "Information",
            informationRequestedFromBank: "Informations demandees a la banque",
            installment: "Echeance",
            installmentDetails: "Details de l'echeance",
            interestRate: "Taux d'interet",
            ipAddress: "Adresse IP",
            keySoilNutrientLevelsForTheFarm: "Principaux niveaux de nutriments du sol pour l'exploitation.",
            landSuitabilityReport: "Rapport d'aptitude des terres",
            lastName: "Nom",
            loadingData: "Chargement des donnees...",
            loanAmount: "Montant du pret",
            loanApplicationDetails: "Details de la demande de pret",
            loanApplicationHasBeenApproved: "La demande de pret a ete approuvee.",
            loanApplicationHasBeenRejected: "La demande de pret a ete rejetee.",
            loanApplications: "Demandes de pret",
            loanDetails: "Details du pret",
            loanDetailsSummary: "Resume des details du pret.",
            loanDisbursementBankFarmer: "Deboursement du pret (Banque -> Agriculteur)",
            loanDisbursementPlan: "Plan de deboursement du pret",
            loanProgram: "Programme de pret",
            loanPrograms: "Programmes de pret",
            loanRepaymentFarmerBank: "Remboursement du pret (Agriculteur -> Banque)",
            loanRepaymentPlan: "Plan de remboursement du pret",
            missingApplicationId: "ID de la demande manquant.",
            moderate: "Modere",
            notApplicable: "N/D",
            nitrogenContent: "Teneur en azote",
            noAdditionalQuestions: "Aucune question supplementaire.",
            noContractIsAlreadySignedOrWillBeSignedOffline: "Non — le contrat est deja signe ou le sera hors ligne",
            noMapCoordinatesForThisFarm: "Aucune coordonnee cartographique pour cette exploitation.",
            notes: "Notes",
            numberOfDisbursements: "Nombre de deboursements",
            numberOfInstallments: "Nombre d'echeances",
            of: "sur",
            openFile: "Ouvrir le fichier",
            orDragAndDropHere: "ou glisser-deposer ici",
            overallLandSuitabilityScoreAndCategory: "Score global d'aptitude des terres et categorie.",
            overallScoreForLandSuitability: "Score global d'aptitude des terres",
            paid: "Paye",
            paymentDetails: "Details du paiement",
            payments: "Paiements",
            pending: "En attente",
            phoneNumber: "Telephone",
            phosphorusContent: "Teneur en phosphore",
            pleaseEnterAValidInterestRateToGenerateRepaymentPlan: "Saisissez un taux d'interet valide pour generer le plan de remboursement.",
            pleaseEnterAValidLoanAmountToGenerateDisbursementPlan: "Saisissez un montant de pret valide pour generer le plan de deboursement.",
            pleaseEnterAValidLoanAmountToGenerateRepaymentPlan: "Saisissez un montant de pret valide pour generer le plan de remboursement.",
            pleaseEnterNumberOfInstallmentsToGenerateRepaymentPlan: "Saisissez le nombre d'echeances pour generer le plan de remboursement.",
            pleaseEnterYourCommentsOrInstructions: "Saisissez vos commentaires ou instructions.",
            pleaseProvideSpecificCommentsOrInstructionsInTheTextBoxBelowOnceSubmittedTheFarmerWillBeNotifiedYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Indiquez des commentaires ou instructions precis dans la zone de texte. Une fois envoye, l'agriculteur sera notifie. Vous serez notifie lorsque l'agriculteur mettra a jour la demande.",
            polygon: "Polygone",
            potassiumContent: "Teneur en potassium",
            principalAndInterest: "Capital et interets",
            print: "Imprimer",
            projectedYieldComparisonByYear: "Comparaison des rendements projetes par annee.",
            provinceState: "Province / Etat",
            question: "Question",
            recordsPerPage: "Enregistrements par page",
            regionDistrict: "Region / District",
            reject: "Rejeter",
            rejected: "Rejete",
            repaymentScheduleFromFarmerToBank: "Calendrier de remboursement de l'agriculteur vers la banque.",
            requestAdditionalInformation: "Demander des informations supplementaires",
            restoreDefault: "Restaurer les defauts",
            search: "Rechercher",
            select: "Selectionner",
            selectFileToUploadTheContract: "Selectionnez le fichier pour televerser le contrat",
            selectNoIfYouHaveAlreadySignedTheContractWithTheApplicantFarmerSelectYesIfYouWantTheApplicantFarmerToSignTheLoanContractOnHisDimitraMobileApp: "Selectionnez Non si vous avez deja signe le contrat avec le demandeur (agriculteur). Selectionnez OUI si vous souhaitez que le demandeur (agriculteur) signe le contrat de pret dans l'application mobile Dimitra.",
            send: "Envoyer",
            sendToBank: "Envoyer a la banque",
            sentToBank: "Envoye a la banque",
            signedOffline: "Signe hors ligne",
            soilAnalysisReport: "Rapport d'analyse de sol",
            someDisclaimerOrShortExplainerAboutFollowingReports: "Bref avertissement ou explication concernant les rapports ci-dessous.",
            srd: "SRD",
            startDate: "Date de debut",
            status: "Statut",
            statusLegend: "Legende des statuts",
            submissionDate: "Date de soumission",
            success: "Succes",
            tapTheMapToExpandIt: "Appuyez sur la carte pour l'agrandir.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponses: "Cette section affiche les demandes d'informations supplementaires envoyees a l'agriculteur et ses reponses.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponsesYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Cette section affiche les demandes d'informations supplementaires envoyees a l'agriculteur et ses reponses. Vous serez notifie lorsque l'agriculteur mettra a jour la demande.",
            totalInstallments: "Total des echeances",
            totalInterestApprox: "Interets totaux (approx.)",
            totalLoanAmount: "Montant total du pret",
            totalPayment: "Paiement total",
            totalRepayment: "Remboursement total",
            transactionIdAndDate: "ID de transaction et date",
            typeYourLocationNameAddress: "Saisissez le nom ou l'adresse de votre emplacement",
            upcoming: "A venir",
            uploadTheUnsignedContractAfterYouAttachAndSaveItWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Televersez le contrat non signe. Apres avoir joint et enregistre, il sera envoye a l'agriculteur pour signature. Vous recevrez une notification une fois signe.",
            user: "Utilisateur",
            userDetails: "Details de l'utilisateur",
            userRole: "Role de l'utilisateur",
            validation: "Validation",
            viewFullReport: "Voir le rapport complet",
            viewGeolocation: "Voir la geolocalisation",
            villageTownCity: "Village / Ville",
            waitingSignatures: "En attente de signatures",
            warning: "Avertissement",
            year2025: "2025",
            year2026: "2026",
            yesAttachTheContractAndWeLlSendItToTheFarmerToSignInTheApp: "Oui — joignez le contrat et nous l'enverrons a l'agriculteur pour signature dans l'application",
            yieldPredictionReport: "Rapport de prevision de rendement",
            youMayUploadTheSignedContractForYourRecordsOrLeaveEmptyIfTheContractIsPrivateOrSignedOffline: "Vous pouvez televerser le contrat signe pour vos archives, ou laisser vide s'il est confidentiel ou signe hors ligne.",
            yourRequestHasBeenSentTheFarmerWillBeNotified: "Votre demande a ete envoyee. L'agriculteur sera notifie.",
            yieldForecastChartAria: "Graphique de prevision de rendement",
            yearsAxisLabel: "Annees",
            soilAnalysisSectionTitle: "Analyse de sol",
            soilMetricNitrogenN: "Azote (N)",
            soilMetricPhosphorusP: "Phosphore (P2O5)",
            soilMetricPotassiumK: "Potassium (K2O)",
            soilAnalysisPlaceholderTitle: "Ce que cela signifie (placeholder)",
            soilAnalysisPlaceholderBody: "Cette page presente un resume simplifie des nutriments du sol. Une fois la source de donnees integree, cette section pourra etre enrichie de graphiques de profil complet et de recommandations.",
            landSuitabilitySectionTitle: "Aptitude des terres",
            overallSuitabilityScoreLabel: "Score global d'aptitude",
            suitabilityFactorsPlaceholder: "Facteurs d'aptitude (placeholder)",
            factorSoilQuality: "Qualite du sol",
            factorClimateFit: "Adequation climatique",
            factorWaterAvailability: "Disponibilite en eau",
            factorRiskFactors: "Facteurs de risque",
            landSuitabilityExpertFooter: "L'IA peut se tromper ; verifiez aupres d'agronomes locaux avant de decider.",
        },
        banks: {
            title: 'Banques',
            addNewBank: 'Ajouter une nouvelle banque',
            bankDetails: 'Details de la banque',
            bank: 'Banque',
            bankTitle: 'Titre de la banque',
            attachBankLogo: 'Ajouter le logo de la banque',
            addImage: 'Ajouter une image',
            contactDetails: 'Coordonnees',
            firstName: 'Prenom',
            lastName: 'Nom',
            email: 'E-mail',
            phone: 'Numero de telephone',
            enterHere: 'Saisissez ici',
            apiIntegrationInfo: 'Informations d integration API',
            apiBaseUrl: 'URL de base API',
            clientId: 'ID client / Cle publique',
            clientSecret: 'Secret client / Cle privee',
            accountAdminCredentials: 'Identifiants compte/administrateur',
            adminUsername: 'Nom d utilisateur administrateur',
            password: 'Mot de passe',
            require2FA: 'Exiger la double authentification',
            enable: 'Activer',
            copy: 'Copier',
            regenerate: 'Regenerer',
            edit: 'Modifier',
            back: 'Retour',
            cancel: 'Annuler',
            save: 'Enregistrer',
            firstNameInfo: 'Informations sur le prenom',
            lastNameInfo: 'Informations sur le nom',
            emailInfo: 'Informations sur l e-mail',
            phoneInfo: 'Informations sur le numero de telephone',
            apiBaseUrlInfo: 'Informations sur l URL de base API',
            clientIdInfo: 'Informations sur l ID client',
            clientSecretInfo: 'Informations sur le secret client',
            adminUsernameInfo: 'Informations sur le nom d utilisateur administrateur',
            passwordInfo: 'Informations sur le mot de passe',
            contactPerson: 'Personne de contact',
            management: 'Gestion financiere',
            editBank: 'Modifier la banque',
            changeImage: 'Changer l image',
            failedToLoadBankDetails: 'Echec du chargement des details de la banque',
            bankUpdatedSuccessfully: 'Banque mise a jour avec succes',
            bankCreatedSuccessfully: 'Banque creee avec succes',
            errorUpdatingBank: 'Erreur lors de la mise a jour de la banque',
            errorCreatingBank: 'Erreur lors de la creation de la banque',
            bankLogo: 'Logo de la banque',
            bankLogoPreview: 'Apercu du logo de la banque',
            notAvailable: 'N/D',
        },
        dashboard: {
            title: "Tableau de bord financier",
            avgLoanAmount: "Montant moyen du pret",
            vsLastMonth: "vs mois dernier",
            totalApplications: "Nombre total de demandes",
            approvalRate: "Taux d approbation",
            loanApplicationsChart: "Demandes de pret",
            applicationsByStatus: "Demandes par statut",
            applicationsByRegion: "Demandes par region",
            regionBreakdown: "Repartition par region",
            averageLoanAmountTrend: "Tendance du montant moyen du pret",
            loanAmountOverTime: "Montant du pret au fil du temps",
            avgAmount: "Montant moyen"
        },
        status: {
            approved: "Approuve",
            pending: "En attente",
            waiting: "Attente",
            rejected: "Rejete"
        },
        reports: {
            today: "Aujourd hui",
            week: "Semaine",
            month: "Mois",
            year: "Annee"
        },
    },
}
